import _ from 'lodash';

/** Turns "the quick brown Fox" into "The quick brown fox" */
export function sentenceCase<T extends string>(str: T): SentenceCase<T> {
  return _.capitalize(str) as SentenceCase<T>;
}
export type SentenceCase<T extends string> = Capitalize<Lowercase<T>>;

/** Turns "theQuickBrownFox" into "The quick brown fox" */
export function sentenceCaseFromCamelCase<T extends string>(str: T) {
  // https://stackoverflow.com/a/7888303/15295209
  const spaced = str.split(/(?=[A-Z])/).join(' ');
  return _.capitalize(spaced) as SentenceCaseFromCamelCase<T>;
}
export type SentenceCaseFromCamelCase<T extends string> = SentenceCase<
  SpaceCaseFromCamelCase<T>
>;
// https://stackoverflow.com/a/65642944/15295209
type SpaceCaseFromCamelCase<S extends string> = S extends `${infer T}${infer U}`
  ? `${T extends Capitalize<T>
      ? ' '
      : ''}${Lowercase<T>}${SpaceCaseFromCamelCase<U>}`
  : Lowercase<S>;

/** Turns "the-quick-brown-fox" into "The quick brown fox" */
export function sentenceCaseFromKebabCase<T extends string>(str: T) {
  const spaced = str.split('-').join(' ');
  return _.capitalize(spaced) as SentenceCaseFromKebabCase<T>;
}
export type SentenceCaseFromKebabCase<T extends string> = SentenceCase<
  SpaceCaseFromKebabCase<T>
>;
type SpaceCaseFromKebabCase<S extends string> =
  S extends `${infer T}-${infer U}`
    ? `${Lowercase<T>} ${SpaceCaseFromKebabCase<U>}`
    : Lowercase<S>;

/** Turns "the_quick_brown_fox" into "The quick brown fox" */
export function sentenceCaseFromSnakeCase<T extends string>(str: T) {
  const spaced = str.split('_').join(' ');
  return _.capitalize(spaced) as SentenceCaseFromSnakeCase<T>;
}
export type SentenceCaseFromSnakeCase<T extends string> = SentenceCase<
  SpaceCaseFromSnakeCase<T>
>;
type SpaceCaseFromSnakeCase<S extends string> =
  S extends `${infer T}_${infer U}`
    ? `${Lowercase<T>} ${SpaceCaseFromSnakeCase<U>}`
    : Lowercase<S>;
